/** Whether the store has a rating to display. */
export function hasStoreRating(averageRating: number | null): averageRating is number {
  return averageRating !== null
}
